import React, { useEffect } from "react";
import "./Footer.css";
import { Link, useLocation } from "react-router-dom";
import Form from "react-bootstrap/Form";

const Footer = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  }, [pathname]);
  return (
    <>
      <section className="footer_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-2 col-sm-12 mb-3 ">
              <div className="footlogodiv mb-2">
                <Link to="/">
                  <img
                    className="footlogoimg"
                    src="/assets/images/logo/Pm-Road-logo.jpg"
                    alt="pmroadlogo"
                  />
                </Link>
              </div>
            </div>

            <div className="col-lg-4 col-sm-6  col-8 mb-3">
              <div className="menusec">
                <h6 className="menutitle">Quick Links</h6>

                <div className="menudiv">
                  <Link
                    to="/"
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  >
                    {" "}
                    Home{" "}
                  </Link>
                </div>

                <div className="menudiv">
                  <Link
                    to="/about-us"
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  >
                    About Us
                  </Link>
                </div>

                <div className="menudiv">
                  <Link
                    to="/contact-us"
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  >
                    Contact Us
                  </Link>
                </div>

                <div className="menudiv">
                  <Link
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    to="privacy-policy"
                  >
                    Privacy Policy
                  </Link>
                </div>

                <div className="menudiv">
                  <Link
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    to="terms-conditions"
                  >
                    Terms & Conditions (Users)
                  </Link>
                </div>

                <div className="menudiv">
                  <Link
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    to="terms-conditions-drivers"
                  >
                    Terms & Conditions (Owner)
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-sm-6  col-12 mb-3 ">
              <div className="menusec">
                <h6 className="menutitle">Contact Us</h6>
                <div className="contact-item">
                  <img
                    src="/assets/images/footer/location.png"
                    className="icon "
                    alt="location icon"
                  />
                  <p className="contact-text">
                    <b>Head Office:</b> 1st floor, AtoZ, Botad Road,
                    Gadhada-364750, Gujrat, India.
                    <br />
                    <b> Branch Office:</b> 112, 99-Business Center, Amroli to
                    Sayan Road-394107, Surat, India.
                  </p>
                </div>

                <div className="contact-item">
                  <img
                    src="/assets/images/footer/phone.png"
                    className="icon"
                    alt="phone icon"
                  />
                  <a href="tel:+919876543210" className="contact-text">
                    <p>
                      <b>Customer Care:</b> +91 94087 24365
                    </p>
                  </a>
                </div>

                <div className="contact-item">
                  <img
                    src="/assets/images/footer/phone.png"
                    className="icon"
                    alt="phone icon"
                  />
                  <a href="tel:+919876543210" className="contact-text">
                    <p>
                      <b>Help Center:</b> +91 8347024365
                    </p>
                  </a>
                </div>

                <div className="contact-item">
                  <img
                    src="/assets/images/footer/phone.png"
                    className="icon"
                    alt="phone icon"
                  />
                  <a href="tel:+919876543210" className="contact-text">
                    <p>
                      <b>Toll Free:</b> +91 1800 24365
                    </p>
                  </a>
                </div>

                <div className="contact-item">
                  <img
                    src="/assets/images/footer/message.png"
                    className="icon"
                    alt="email icon"
                  />
                  <div className="all_links_holder">
                    <div className="links_holder">
                      <a
                        href="mailto:help.pmroad@gmail.com"
                        className="contact-text"
                      >
                        help.pmroad@gmail.com
                      </a>
                    </div>

                    <div className="links_holder">
                      <a
                        href="mailto:info.pmroad@gmail.com"
                        className="contact-text"
                      >
                        info.pmroad@gmail.com
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-2 col-md-3 col-sm-12 mb-3 ">
              <div className="menusec">
                <h6 className="menutitle">Applications Link</h6>
                <div className="socialicons">
                  <Link
                    to={
                      "https://play.google.com/store/apps/details?id=com.pmroaddriver"
                    }
                    target="_blank"
                    style={{ width: "fit-content" }}
                  >
                    <img
                      className="icon"
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/footer/driver.webp"
                      }
                    />
                  </Link>
                  <Link
                    to={
                      "https://play.google.com/store/apps/details?id=com.pmroadcustomer"
                    }
                    target="_blank"
                    style={{ width: "fit-content" }}
                  >
                    <img
                      className="icon"
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/footer/user.webp"
                      }
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-md-4 col-12 text-md-start">
              <div className="menusec">
                <h6 className="menutitle mb-2">Sponsor By</h6>
                <div className="menudiv d-flex">
                  <img
                    className="interlogo"
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/logo/vaghani-business-removebg-preview.png"
                    }
                    alt=""
                  />
                  <Link to="#">
                    Vaghani International Business Private Limited
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-md-4 col-12 text-md-center ">
              <div className="menusec">
                <h6 className="menutitle ">Follow Us</h6>
                <div className="socialicons">
                  <Link
                    to={"https://www.facebook.com/share/17xh1pQu18/"}
                    target="_blank"
                    style={{ width: "fit-content" }}
                  >
                    <img
                      className="icon"
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/footer/facebook.png"
                      }
                    />
                  </Link>

                  <Link
                    to={"https://youtube.com/@pmroad?si=-8XQNJt4daYb2WiF"}
                    target="_blank"
                    style={{ width: "fit-content" }}
                  >
                    <img
                      className="icon"
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/footer/youtube.png"
                      }
                    />
                  </Link>

                  <Link
                    to={"https://x.com/PMROAD1"}
                    target="_blank"
                    style={{ width: "fit-content" }}
                  >
                    <img
                      className="icon"
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/footer/twitter.png"
                      }
                    />
                  </Link>

                  <Link
                    to={
                      "https://www.instagram.com/pm.road?utm_source=qr&igsh=MXdubzJpbnI4ODhkdA=="
                    }
                    target="_blank"
                    style={{ width: "fit-content" }}
                  >
                    <img
                      className="icon"
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/footer/instagram.png"
                      }
                    />
                  </Link>

                  <Link
                    to={"https://www.threads.com/@pm.road"}
                    target="_blank"
                    style={{ width: "fit-content" }}
                  >
                    <img
                      className="icon"
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/footer/thread.png"
                      }
                    />
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-md-4 col-12 text-md-end">
              <div className="menusec">
                <h6 className="menutitle mb-2">Supported By</h6>
                <div className="menudiv d-flex justify-content-md-end justify-content-start">
                  <img
                    className="interlogo"
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/logo/vaghani-energy-removebg-preview.png"
                    }
                    alt=""
                  />
                  <Link to="#"> Vaghani Energy Limited</Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divider" />

        <div className="copyrightsec">
          <p className="copyrightp">
            © {new Date().getFullYear()} PM Road All Rights Reserved . Developed
            by{" "}
            <Link to={"https://profcymaglobal.com/"} target="_blank">
              Profcyma
            </Link>
          </p>
        </div>
      </section>
    </>
  );
};

export default Footer;
